import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import '@/App.css';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import ContractsList from './pages/ContractsList';
import ContractDetail from './pages/ContractDetail';
import AdminPanel from './pages/AdminPanel';
import MarketRates from './pages/MarketRates';
import MyQueuePage from './pages/MyQueuePage';
import ExecutiveDashboard from './pages/ExecutiveDashboard';
import AdvancedMapView from './pages/AdvancedMapView';
import TerritoryMapView from './pages/TerritoryMapView';
import TerritoryComparison from './pages/TerritoryComparison';
import TerritoryTrends from './pages/TerritoryTrends';
import PredictiveForecasting from './pages/PredictiveForecasting';
import CompetitiveIntelligence from './pages/CompetitiveIntelligence';
import ESGDashboard from './pages/ESGDashboard';
import ForecastingDashboard from './pages/ForecastingDashboard';
import About from './pages/About';
import Layout from './components/Layout';
import { Toaster } from './components/ui/sonner';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

function ProtectedRoute({ children }) {
  const token = localStorage.getItem('ccip_token');
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  return children;
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route
              path="/*"
              element={
                <ProtectedRoute>
                  <Layout>
                    <Routes>
                      <Route path="/" element={<Dashboard />} />
                      <Route path="/executive" element={<ExecutiveDashboard />} />
                      <Route path="/queue" element={<MyQueuePage />} />
                      <Route path="/contracts" element={<ContractsList />} />
                      <Route path="/contracts/:id" element={<ContractDetail />} />
                      <Route path="/admin" element={<AdminPanel />} />
                      <Route path="/market-rates" element={<MarketRates />} />
                      <Route path="/map" element={<AdvancedMapView />} />
                      <Route path="/map/territory" element={<TerritoryMapView />} />
                      <Route path="/map/compare" element={<TerritoryComparison />} />
                      <Route path="/map/trends" element={<TerritoryTrends />} />
                      <Route path="/predictions" element={<PredictiveForecasting />} />
                      <Route path="/competitive" element={<CompetitiveIntelligence />} />
                      <Route path="/esg" element={<ESGDashboard />} />
                      <Route path="/forecasting" element={<ForecastingDashboard />} />
                      <Route path="/about" element={<About />} />
                    </Routes>
                  </Layout>
                </ProtectedRoute>
              }
            />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </div>
    </QueryClientProvider>
  );
}

export default App;
